import { LegalPage } from "./legal/LegalPage";
import LanguagePolicyDocument from "./dynamic/LanguagePolicy";

export default function LanguagePolicyComponent() {
  return (
    <LegalPage path="/languagepolicy">
      <LanguagePolicyDocument />
    </LegalPage>
  );
}
